import { render, staticRenderFns } from "./ColumnPair.vue?vue&type=template&id=3cf859be&scoped=true&"
import script from "./ColumnPair.vue?vue&type=script&lang=ts&"
export * from "./ColumnPair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf859be",
  null
  
)

export default component.exports